import React, { useContext } from 'react';
import { ZdsAlert } from '@zig-design-system/ui-components-react';
import Translation from './Translation';
import { renderToString } from 'react-dom/server';
import LogApiService, { LogTypes } from '../services/LogApiService';
import { RootContext } from '../../Context/RootContext';
export var AlertType;
(function (AlertType) {
    AlertType["error"] = "error";
    AlertType["warning"] = "warning";
    AlertType["info"] = "info";
    AlertType["success"] = "success";
})(AlertType || (AlertType = {}));
const Alert = ({ title = 't(alert.warning.title)', message = null, type = AlertType.info }) => {
    let alertContent = message;
    if (message) {
        switch (true) {
            case message instanceof TypeError:
                alertContent = message.message;
                break;
            case typeof message === 'object':
                alertContent = message.hasOwnProperty('message') ? message.message : alertContent;
                break;
            case typeof message === 'string':
                if (message.startsWith('t(')) {
                    alertContent = (React.createElement(Translation, { item: message.substring(message.indexOf('t(') + 2, message.lastIndexOf(')')) }));
                }
                else {
                    alertContent = message;
                }
                break;
        }
    }
    if (title.startsWith('t(')) {
        title = renderToString(React.createElement(Translation, { item: title, asString: true }));
    }
    if ([AlertType.error, AlertType.warning].includes(type)) {
        let apiType;
        switch (type) {
            case AlertType.error:
                apiType = LogTypes.error;
                break;
            case AlertType.warning:
                apiType = LogTypes.warning;
                break;
            default:
                apiType = LogTypes.error;
                break;
        }
        LogApiService.log(title, message, useContext(RootContext).pageContext.marathonAppId, apiType);
    }
    return (React.createElement(ZdsAlert, { type: type },
        title,
        alertContent && React.createElement("div", { slot: "body" }, alertContent)));
};
export default Alert;
